// Short elusive quote from The Architect.
import { ARCHITECT } from "@/data/characters";

export const ArchitectNote = ({ quote }) => (
  <div className="mx-auto flex max-w-xl items-center gap-5 border border-gold/25 bg-charcoal/70 p-5 sm:p-6" data-testid="architect-note">
    <div className="relative h-16 w-16 shrink-0 overflow-hidden rounded-full border border-gold/40 sm:h-20 sm:w-20">
      <img src={ARCHITECT.img} alt="The Architect" className="h-full w-full object-cover object-top" style={{ filter: "grayscale(0.7) brightness(0.75)" }} loading="lazy" />
      <div className="absolute inset-0 rounded-full shadow-[inset_0_0_25px_rgba(0,0,0,0.85)]" />
    </div>
    <div className="text-left">
      <p className="font-mono text-[9px] uppercase tracking-[0.35em] text-gold">The Architect</p>
      <p className="mt-2 font-cinzel text-sm uppercase tracking-[0.12em] text-cream/90 sm:text-base">"{quote}"</p>
    </div>
  </div>
);
